import { render, staticRenderFns } from "./LegalStatusDetails.vue?vue&type=template&id=96657728&scoped=true&"
import script from "./LegalStatusDetails.vue?vue&type=script&lang=js&"
export * from "./LegalStatusDetails.vue?vue&type=script&lang=js&"
import style0 from "./LegalStatusDetails.vue?vue&type=style&index=0&id=96657728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96657728",
  null
  
)

export default component.exports